import styled from 'styled-components';

const ReviewCard = styled.div`
  padding: 14px 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;
`;

export default ReviewCard;
